module.exports = __webpack_public_path__ + "static/media/esportsWhite.49d3251d.svg";